import { Tooltip } from 'antd/lib'
import { t } from 'i18next'
import styled from 'styled-components'
import SimpleSwitch from './SimpleSwitch'
import SimpleSwitchContainer from './display/SimpleSwitchContainer'

interface InclusionSwitchProps {
  id?: string
  checked?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: (value: boolean) => void
  tooltipText?: string
}

const InclusionSwitchText = styled.div`
  &.disabled {
    color: var(--colorTextDisabled, rgba(255, 255, 255, 0.25));
  }
`

const InclusionSwitch = ({
  id,
  checked,
  tooltipText,
  ...props
}: InclusionSwitchProps) => {
  const content = (
    <InclusionSwitchText
      data-testid={`simple-switch-text-${id}`}
      className={props.disabled ? 'disabled' : ''}
    >
      {checked ? t('Included') : t('Excluded')}
    </InclusionSwitchText>
  )

  return (
    <SimpleSwitchContainer>
      <SimpleSwitch
        data-testid={`simple-switch-${id}`}
        checked={checked}
        {...props}
      />
      {tooltipText && props.disabled ? (
        <Tooltip title={tooltipText}>{content}</Tooltip>
      ) : (
        content
      )}
    </SimpleSwitchContainer>
  )
}

export default InclusionSwitch
